import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OpcaoVisualizacao = _resolveComponent("OpcaoVisualizacao")!
  const _component_OpcaoEdicao = _resolveComponent("OpcaoEdicao")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.opcao.getEmEdicao())
      ? (_openBlock(), _createBlock(_component_OpcaoVisualizacao, {
          key: 0,
          opcao: _ctx.opcao,
          ehPrimeiro: _ctx.ehPrimeiro,
          ehUltimo: _ctx.ehUltimo,
          onEditar: _ctx.editar,
          onExcluir: _ctx.excluir,
          onDescer: _ctx.descer,
          onSubir: _ctx.subir
        }, null, 8, ["opcao", "ehPrimeiro", "ehUltimo", "onEditar", "onExcluir", "onDescer", "onSubir"]))
      : _createCommentVNode("", true),
    (_ctx.opcao.getEmEdicao())
      ? (_openBlock(), _createBlock(_component_OpcaoEdicao, {
          key: 1,
          opcao: _ctx.opcao
        }, null, 8, ["opcao"]))
      : _createCommentVNode("", true)
  ]))
}